<template>
    <div
        v-if="!isPrinting"
        id="printServiceBtn"
        class="console-btn print-service"
        :class="{ 'btn-with-text': withText, BtnShowMember: !isAuthorized }"
        data-tour-target="print-service"
        @click="onPrintClick"
    >
        <svg-icon icon-name="printer-regular" color="#888888"></svg-icon>
        <div v-if="withText" class="console-ill">列印商品清單</div>
        <slot name="tooltip"></slot>
    </div>
</template>

<script setup lang="ts">
    import { onBeforeUnmount, onMounted, ref } from 'vue';
    import SvgIcon from '@/components/base/SvgIcon.vue';

    interface PrintUtilsBridge {
        GetPrintStatus: () => boolean;
        TogglePrintMode: () => void;
    }

    // ----- props -----
    const props = withDefaults(
        defineProps<{
            isAuthorized?: boolean;
        }>(),
        {
            isAuthorized: false,
        }
    );

    // ----- state -----
    const withText = ref(true);
    const isPrinting = ref(false);

    const getPrintUtils = (): PrintUtilsBridge | null => {
        const runtimePrintUtils = (
            window as Window & { PrintUtils?: PrintUtilsBridge }
        ).PrintUtils;
        return runtimePrintUtils ?? null;
    };

    // ----- methods -----
    // 畫面滾動超過 150px 時，不顯示文字
    const handleScroll = (): void => {
        withText.value = window.scrollY <= 150;
    };

    // 執行 PrintUtils.TogglePrintMode 後更新列印狀態
    const updatePrintStatus = (): void => {
        const printUtils = getPrintUtils();
        isPrinting.value = printUtils ? printUtils.GetPrintStatus() : false;
    };

    // 切換列印模式
    const togglePrintMode = (): void => {
        const printUtils = getPrintUtils();
        printUtils?.TogglePrintMode();
    };

    const onPrintClick = (): void => {
        if (!props.isAuthorized) {
            return;
        }

        togglePrintMode();
    };

    onMounted(() => {
        updatePrintStatus();
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('UpdatePrintStatus', updatePrintStatus);
    });

    onBeforeUnmount(() => {
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('UpdatePrintStatus', updatePrintStatus);
    });
</script>

<style scoped lang="scss">
    .console-btn.print-service {
        position: relative;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        display: none;
        align-items: center;
        justify-content: center;
        padding: 4px 8px;
        background-color: #ffffff;
        border: 1px solid $grayColorE7;
        cursor: pointer;

        &.btn-with-text {
            width: 64px;
            height: 64px;
        }

        @include rwd($mobile) {
            display: flex;
            flex-direction: column;
        }

        .console-ill {
            color: $textColor888;
            font-size: 0.75rem;
            text-align: center;
        }
    }
</style>
